import { faUtensils } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import "../../i18n";
import { TemporalSelectorModes } from "../../layouts/TemporalSelector/TemporalSelector";
import ChartTotalsComponent from "./chartTotals.component";
import DashboardChartWrapper from "./dashboardChartWrapper.component";
import { IstogramData } from "./DashboardComponent";
import DashboarcComponentTitle from "./DashboardComponentTitle";

interface DashboardIstogramDailyCoversProps {
	data: IstogramData[];
	mode: TemporalSelectorModes;
	responsiveContainerClassName: string;
}

const DashboardIstogramDailyCovers: React.FC<DashboardIstogramDailyCoversProps> = (props) => {
	const { t } = useTranslation();

	const totals = useMemo(
		() => [
			{
				label: t("dashboard.current"),
				value: props.data.length > 0 ? props.data[0]?.covers ?? 0 : 0,
				color: "#8884d8",
				fontSize: "3.5vw"
			},
			{
				label: t("dashboard.previous"),
				value: props.data.length > 0 ? props.data[1]?.covers ?? 0 : 0,
				color: "#888412"
			}
		],
		[props.data]
	);

	const title =
		props.mode === TemporalSelectorModes.week ? t("dashboard.titles.weekly.total_covers_number") : t("dashboard.titles.monthly.total_covers_number");

	return (
		<DashboardChartWrapper>
			<DashboarcComponentTitle title={title} />

			<ChartTotalsComponent totals={totals} mainTotal={0} compareTotal={1} deltaSuffix={<FontAwesomeIcon icon={faUtensils} />} />
			<ResponsiveContainer height={160} className={props.responsiveContainerClassName}>
				<BarChart
					width={500}
					height={300}
					data={props.data ?? []}
					margin={{
						top: 5,
						right: 30,
						left: 20,
						bottom: 5
					}}
				>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="name" />
					<YAxis />
					<Tooltip />
					<Bar dataKey="covers" name={t("shared.cover")} fill="#888412" />
				</BarChart>
			</ResponsiveContainer>
		</DashboardChartWrapper>
	);
};

export default DashboardIstogramDailyCovers;
